import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import en from './translations/en.json'; // English
import de from './translations/de.json'; // German
import it from './translations/it.json'; // Italian
import fr from './translations/fr.json'; // French

const resources = {
  en: { translation: en },
  de: { translation: de },
  it: { translation: it },
  fr: { translation: fr },
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'en', // Default language if user's language isn't available
    interpolation: {
      escapeValue: false, // React already escapes values, so this is safe
    },
  });

export default i18n;
